import React, { useEffect, useState } from "react";

export default function SplashComponent({
  className = "",
  logo,
  title,
  backgroundImage,
  rotatingImages = [],
  minis = [],
  orderButtonText = "ORDER & PAY HERE",
  touchText = "Touch anywhere to begin",
  onClick,
}) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!rotatingImages.length) return;

    const interval = setInterval(() => {
      setIndex((i) => (i + 1) % rotatingImages.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [rotatingImages]);

  return (
    <div className={`splash-wrapper ${className}`} onClick={onClick}>

      {/* Floating mini icons */}
      {minis.map((m, i) => (
        <img key={i} src={m} alt="" className={`mini mini-${i}`} />
      ))}

      {/* Logo + Title */}
      <h1 className="title">
        {logo && <img src={logo} alt="logo" className="logo" />}
        {title}
      </h1>

      {/* Main Content */}
      <div className="content">

        {/* Background Plate */}
        <div className="food-wrapper">
          {backgroundImage && (
            <img src={backgroundImage} className="food-bg" alt="bg" />
          )}

          {rotatingImages.length > 0 && (
            <img
              src={rotatingImages[index]}
              className="food-main"
              alt="food"
            />
          )}
        </div>

        <button className="order-btn">{orderButtonText}</button>

        <p className="touch-text">{touchText}</p>


      </div>
    </div>
  );
}